import axios from '@/services/api'

/**
 * @returns {Promise<Object>}
 */
export const fetchTags = (page) => {
	const url = `/api/tags?page=${page}`
	return axios.get(url)
}

/**
 * @returns {Promise<Object>}
 */
export const fetchPopularTags = (query) => {
	const url = '/api/tags/popular'
	return axios.get(url, { params: query })
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addTag = (data) => {
	const url = `/api/tags`
	return axios.post(url, data)
}

/**
 * @param {Number} id tag ID
 * @returns {Promise<Object>}
 */
export const deleteTag = (id) => {
	const url = `/api/tags/${id}`
	return axios.delete(url)
}
